import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=76ecfabc&scoped=true"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"
import style0 from "./tags.vue?vue&type=style&index=0&id=76ecfabc&prod&scoped=true&lang=scss"
import style1 from "./tags.vue?vue&type=style&index=1&id=76ecfabc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ecfabc",
  null
  
)

export default component.exports